import React from 'react';

import MagicStarIcon from 'assets/icons/star-rating.svg';

import classes from './StarRate.module.scss';

const StarRate = ({ rate_average }) => {
    return (
        <div className={classes['wrapper']}>
            {rate_average === 0 ? (
                <div>
                   
                </div>
            ) : (
                <div className='d-flex align-items-center gap-1'>
                    <MagicStarIcon />
                    <h5 className='m-0'>{rate_average}</h5>
                </div>
            )}

        </div>
    );
};

export default StarRate;